import React from "react";
import { Link } from "react-router-dom";
import { companyLink, isExternal } from "../../data/companyLinks";

// ============================================================
// KOT Mega Menus — data Corporate Statutes se
// (Article 18 — Corporate Companies, Article 19 — Strategic Programs)
// Phase 2 me har item ka link us company/program ki site par point karega.
// ============================================================

interface MegaItem {
  title: string;
  desc: string;
  link: string;
  badge?: string;
}

// Har company apne alag domain par deploy hoti hai — link companyLinks.ts se aata hai
// (domain live hone tak main site ke andar preview page khulta hai)
const companies: MegaItem[] = [
  { title: "Digital Systems", desc: "Enterprise intelligence & digital transformation.", link: companyLink("digital-systems") },
  { title: "AppForge", desc: "Human experience engineering.", link: companyLink("appforge") },
  { title: "Venture Xcelerator", desc: "Venture intelligence & acceleration.", link: companyLink("venture-xcelerator") },
  { title: "EpiTech", desc: "Education innovation & industry transformation.", link: companyLink("epitech") },
  { title: "The Founders TX", desc: "Innovation convergence platform.", link: companyLink("the-founders-tx") },
  { title: "Commerce X", desc: "Commerce intelligence.", link: companyLink("commerce-x") },
  { title: "Growth IQ", desc: "Growth intelligence.", link: companyLink("growth-iq") },
  { title: "Visual Systems", desc: "Visual intelligence & creative production.", link: companyLink("visual-systems") },
  { title: "Platform Systems", desc: "Platform economy.", link: companyLink("platform-systems") },
  { title: "Flawless X", desc: "Quality intelligence & operational excellence.", link: companyLink("flawless-x") },
];

const programs: MegaItem[] = [
  { title: "Challenge X", desc: "Global challenge intelligence platform.", link: "/programs/challenge-x", badge: "Flagship" },
  { title: "Platform 9¾", desc: "Immersive themed café experience.", link: "/programs/platform-9-34" },
  { title: "Madad Farma", desc: "Community welfare & human capital initiative.", link: "/programs/madad-farma" },
  { title: "Her X", desc: "Women leadership & enterprise initiative.", link: "/programs/her-x" },
  { title: "Saqafat", desc: "Culture, ethics & creative economy podcast.", link: "/programs/saqafat" },
];

const MegaMenuGrid: React.FC<{ items: MegaItem[]; cta: string }> = ({
  items,
  cta,
}) => (
  <ul className="submenu">
    <li>
      <div className="mega_menu_wrapper">
        <div className="container-fluid p-0">
          <div className="mega_menu_wrapper_inner">
            <div className="row mt-none-30">
              <div className="col-12 mt-30">
                <div className="megamenu_pages_wrapper">
                  <div className="row g-10">
                    {items.map((item) => {
                      const inner = (
                        <>
                          <span className="icon_title_wrap">
                            <small className="iconbox_title">{item.title}</small>
                            {item.badge && (
                              <span className="badge">{item.badge}</span>
                            )}
                          </span>
                          <span className="description mb-0">{item.desc}</span>
                        </>
                      );
                      return (
                        <div className="col-xl-4 col-lg-4" key={item.title}>
                          {isExternal(item.link) ? (
                            <a
                              className="iconbox_block_2"
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {inner}
                            </a>
                          ) : (
                            <Link className="iconbox_block_2" to={item.link}>
                              {inner}
                            </Link>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  <ul className="btns_group mt-80 p-0 ul_li_between">
                    <li>
                      <Link
                        className="thm-btn agency-btn megamenu-btn"
                        to="/#contact"
                      >
                        <span className="text">{cta}</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
);

export const MegaMenuCompanies: React.FC = () => (
  <MegaMenuGrid items={companies} cta="Partner with the Group" />
);

export const MegaMenuPrograms: React.FC = () => (
  <MegaMenuGrid items={programs} cta="Join an Initiative" />
);
